import {useEffect} from 'react';

interface ISetCarouselInterval {
  isSlideshowPaused: boolean;
  currentSlideIndex: number;
  lastSlideIndex: number;
  onSetCurrentSlideIndex: (number: number) => void;
  time: number;
  wrap: boolean;
}

export const useSetCarouselInterval = ({
  isSlideshowPaused,
  currentSlideIndex,
  lastSlideIndex,
  onSetCurrentSlideIndex,
  time,
  wrap,
}: ISetCarouselInterval) => {
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isSlideshowPaused) {
        if (currentSlideIndex === lastSlideIndex - 1) {
          if (wrap) {
            onSetCurrentSlideIndex(0);
          }
        } else {
          onSetCurrentSlideIndex(currentSlideIndex + 1);
        }
      }
    }, time);
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [
    isSlideshowPaused,
    currentSlideIndex,
    lastSlideIndex,
    onSetCurrentSlideIndex,
    time,
    wrap,
  ]);
};
